<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pt-2 px-3 pb-3"
        [class.mt-3]="fromOrderSummary">
        <span class="col-auto col-md-6 head-custom-span">
          <div class="d-flex gap-2 align-items-center">
            <h2 class="m-0 wordwrap d-flex gap-3">
              <span>Propose Project # {{ paddedWorkflowId }}</span>

              <div
                class="lds-ring inline me-auto sm-loader"
                *ngIf="showSmallLoader">
                <jni-spinner></jni-spinner>
              </div>

              <span class="px-3 client-badge">Client: {{ clientName }}</span>

              <span class="px-3 client-badge">Job Name: {{ jobName }}</span>
            </h2>
          </div>
        </span>
        <div class="col-auto col-md-5 inside-custom-span">
          <div
            class="ordersummary-panel ml-auto d-flex justify-content-between pad-right">
            <div
              *ngIf="
                workflowStatus !== 10 && !isCancelDisabled && !isDisableLink
              "
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="cancelProject()">Cancel Project</a>
            </div>
            <div
              *ngIf="workflowStatus === 10"
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="revertCancel()">Revert Cancel</a>
            </div>
            <div
              *ngIf="isDelivered && workflowStatus !== 8 && !isDisableLink"
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="markAsComplete()">Mark Complete</a>
            </div>
            <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="openErrorLogsScreen()"
                ><i class="pi pi-exclamation-triangle"></i> Error Logs</a
              >
            </div>
            <div
              *ngIf="!isDisableLink"
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <a class="link" (click)="getNotificationSettings()"
                ><i class="pi pi-bell"></i> Notification Settings</a
              >
            </div>
            <div
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center"
              *ngIf="isAdmin && !isDisableLink">
              <a class="link delcol" (click)="postDeleteProject()">Delete</a>
            </div>
            <div
              class="ms-3 nav-link p-0 d-flex align-items-center"
              *ngIf="signalRChatBoxShow">
              <a class="link" (click)="showChatBox()">Chat Box </a>
            </div>
            <div
              *ngIf="!isDisableLink || workflowStatus === 10"
              class="ms-3 nav-link p-0 d-flex align-items-center">
              <a class="link" (click)="updateWorkflowHeader(true)"
                ><i class="pi pi-save"></i> Save</a
              >
            </div>
          </div>
        </div>
        <span
          *ngIf="showCloseIcon === true"
          class="cross-border"
          (click)="onCloseModalEvent()"
          ><i class="pi pi-times"></i
        ></span> </span
    ></p-card>
  </div>
</div>

<div
  class="ordersummary py-0 dropover modelsummary"
  [class.mt-3]="fromOrderSummary">
  <div class="">
    <!-- <div
      class="progress-bar-project"
      *ngIf="!isCancelled; else cancelledTemplate">
      <ul id="progress">
        <li class="first" id="step-1" [class.prog-green]="completeStep >= 1">
          Project Created
        </li>
        <li id="step-2" [class.prog-green]="completeStep >= 2">
          Order Written
        </li>
        <li
          id="step-3"
          [class.prog-green]="completeStep >= 3 || workflowStatus === 8"
          [class.prog-yellow]="
            minStep < 3 && maxStep >= 3 && workflowStatus !== 8
          ">
          PO Sent
        </li>
        <li
          id="step-4"
          [class.prog-green]="completeStep >= 4 || workflowStatus === 8"
          [class.prog-yellow]="
            minStep < 4 && maxStep >= 4 && workflowStatus !== 8
          ">
          Proof Sent
        </li>
        <li
          id="step-5"
          [class.prog-green]="completeStep >= 6 || workflowStatus === 8"
          [class.prog-yellow]="
            minStep < 6 && maxStep >= 6 && workflowStatus !== 8
          ">
          Proof Approved
        </li>
        <li
          id="step-6"
          [class.prog-green]="completeStep >= 7 || workflowStatus === 8"
          [class.prog-yellow]="
            ((minStep < 7 && maxStep >= 7) || inProductionColor === 'yellow') &&
            workflowStatus !== 8
          ">
          In Production
        </li>
        <li id="step-6" [ngClass]="shippedColor">Shipped</li>
        <li id="step-6" [ngClass]="deliveredColor">Delivered</li>
        <li
          class="last"
          [class.prog-green]="workflowStatus === 8"
          [class.disabled]="workflowStatus !== 8">
          Complete
        </li>
      </ul>
    </div> -->

    <div class="stepper mt-2 mb-2" *ngIf="!isCancelled; else cancelledTemplate">
      <div
        class="step green first"
        id="step-1"
        [class.prog-green]="completeStep >= 1">
        <div class="number circle-text">01</div>
        <div class="step-content">
          <div class="title">Project Created</div>
        </div>
      </div>

      <div class="step blue" id="step-2" [class.prog-green]="completeStep >= 2">
        <div class="number circle-text">02</div>
        <div class="step-content">
          <div class="title">Order Written</div>
        </div>
      </div>

      <div
        class="step orange"
        id="step-3"
        [class.prog-green]="completeStep >= 3 || workflowStatus === 8"
        [class.prog-yellow]="
          minStep < 3 && maxStep >= 3 && workflowStatus !== 8
        ">
        <div class="number circle-text">03</div>
        <div class="step-content">
          <div class="title">PO Sent</div>
        </div>
      </div>

      <div
        class="step gray"
        id="step-4"
        [class.prog-green]="completeStep >= 4 || workflowStatus === 8"
        [class.prog-yellow]="
          minStep < 4 && maxStep >= 4 && workflowStatus !== 8
        ">
        <div class="number circle-text">04</div>
        <div class="step-content">
          <div class="title">Proof Sent</div>
        </div>
      </div>

      <div
        class="step gray"
        id="step-5"
        [class.prog-green]="completeStep >= 6 || workflowStatus === 8"
        [class.prog-yellow]="
          minStep < 6 && maxStep >= 6 && workflowStatus !== 8
        ">
        <div class="number circle-text">05</div>
        <div class="step-content">
          <div class="title">Proof Approved</div>
        </div>
      </div>

      <div
        class="step gray"
        id="step-6"
        [class.prog-green]="completeStep >= 7 || workflowStatus === 8"
        [class.prog-yellow]="
          ((minStep < 7 && maxStep >= 7) || inProductionColor === 'yellow') &&
          workflowStatus !== 8
        ">
        <div class="number circle-text">06</div>
        <div class="step-content">
          <div class="title">In Production</div>
        </div>
      </div>

      <div class="step gray" [ngClass]="shippedColor">
        <div class="number circle-text">07</div>
        <div class="step-content">
          <div class="title">Shipped</div>
        </div>
      </div>

      <div class="step gray" [ngClass]="deliveredColor">
        <div class="number circle-text">08</div>
        <div class="step-content">
          <div class="title">Delivered</div>
        </div>
      </div>

      <div
        class="step gray last"
        [class.prog-green]="workflowStatus === 8"
        [class.disabled]="workflowStatus !== 8">
        <div class="number circle-text">09</div>
        <div class="step-content">
          <div class="title">Complete</div>
        </div>
      </div>
    </div>
    <ng-template #cancelledTemplate>
      <div
        class="cancelled-status d-flex justify-content-center mb-3 mt-3 p-2 rounded">
        <span>Cancelled</span>
      </div>
    </ng-template>
  </div>

  <div class="col-12 production-workflow-cont adduser-container-hgt px-3">
    <h2 class="pt-2 pb-2 globalborder-btm-header">Header</h2>

    <form [formGroup]="workflowForm" class="">
      <div class="row collapseable">
        <div class="col-3 fixingflexcol" formGroupName="details">
          <div class="gray-bg-rounded min-hgt-rounded">
            <h3 class="mb-2">Details</h3>
            <div class="d-flex gap-2 justify-content-between align-items-end">
              <div class="col-lg">
                <label class="form-label">Proposed Project</label>
                <input
                  pInputText
                  jniAutoCompleteBlocker
                  type="text"
                  class="form-control has-link disable-color"
                  formControlName="workflowId" />
              </div>
            </div>

            <div class="buyerpos">
              <!-- custom -->

              <div class="form-group has-float-label mb-2">
                <label class="form-label">Buyer </label>
                <div
                  class="d-flex gap-2 justify-content-between align-items-end">
                  <div class="col-lg">
                    <input
                      pInputText
                      #mydropBuyer
                      jniAutoCompleteBlocker
                      type="text"
                      id="buyer"
                      name="buyer"
                      class="form-control"
                      formControlName="buyerName"
                      (input)="buyerVendor$.next($any($event.target).value)"
                      (keyup)="
                        onBuyerSearchOpenToggle(
                          projectPopover,
                          $event,
                          mydropBuyer
                        )
                      "
                      (keydown.Tab)="getBuyer($event, projectPopover)"
                      (click)="
                        onBuyerListClick(projectPopover, $event, mydropBuyer)
                      " />
                    <div *ngIf="customerIdWorkFlowDetails !== ''"></div>
                  </div>
                  <a
                    class="small-link no-decoration"
                    (click)="addContactInformation()"
                    >+Add</a
                  >
                </div>
              </div>
              <p-popover
                class="order-dropdown add dropDownPosition search-table-position ps-drop"
                #projectPopover>
                <p-table
                  #dt
                  [value]="buyerLists"
                  styleClass="p-datatable-customers order-listing"
                  [rowHover]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [paginator]="false"
                  [filterDelay]="0">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="name">Buyer</th>
                      <th class="client" pSortableColumn="client">
                        Client
                        <p-sortIcon field="Client"></p-sortIcon>
                      </th>
                      <th class="vaccount">Account</th>
                      <th class="street">Street</th>
                      <th class="city">City</th>
                      <th class="state">State</th>
                      <th class="lastOrderDate">Last order date</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <div class="d-flex">
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            pInputText
                            type="text"
                            name="organizationNameD365"
                            id="organizationNameD365"
                            style="max-width: 200px"
                            (input)="
                              dt.filter(
                                $any($event.target).value,
                                'organizationNameD365',
                                'contains'
                              )
                            "
                            placeholder=""
                            class="p-column-filter p-inputtext p-component" />
                        </div>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-buyerList
                    let-rowIndex="rowIndex">
                    <tr
                      class="p-selectable-row mousepointer"
                      (click)="onBuyerSelection(buyerList, projectPopover)">
                      <td class="buyer mousepointer">
                        {{ buyerList.buyer }}
                      </td>
                      <td class="client mousepointer">
                        {{ buyerList.organizationNameD365 }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ buyerList.account }}
                      </td>
                      <td style="width: 200px" class="sname mousepointer">
                        {{ buyerList.street }}
                      </td>
                      <td class="city mousepointer">{{ buyerList.city }}</td>
                      <td style="width: 72px" class="state mousepointer">
                        {{ buyerList.state }}
                      </td>
                      <td style="width: 75px" class="country mousepointer">
                        {{ buyerList.lastOrder | date: "yyyy-MM-dd" }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="20">No buyer found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-popover>
            </div>
            <div class="d-flex gap-2 justify-content-between align-items-end">
              <div class="col-lg">
                <label class="form-label">BC<span></span></label>
                <p-select
                  formControlName="owner"
                  [filter]="true"
                  [showClear]="true"
                  [options]="brandingConsultantLists"
                  optionLabel="projectName"
                  optionValue="personnelNumber">
                </p-select>
              </div>
              <div class="text-end">
                <a
                  class="pointer no-decoration"
                  *ngIf="!newWorkflowOwnerDisabled && !isDisableLink"
                  (click)="reassingWorkflow()"
                  >Reassign Workflow</a
                >
                <a
                  class="pointer no-decoration"
                  *ngIf="newWorkflowOwnerDisabled"
                  >Pending Request</a
                >
              </div>
            </div>

            <div class="coowner-section">
              <div
                formArrayName="coowners"
                *ngFor="let coowner of coowners.controls; let i = index">
                <div
                  [formGroupName]="i"
                  class="form-group has-float-label mb-1">
                  <label class="form-label">Co-Owner<span></span></label>
                  <p-select
                    class="custom-ng-select"
                    id="{{ 'coowner' + i }}"
                    formControlName="coowner"
                    [filter]="true"
                    [options]="getGroupedFilteredOptions(i)"
                    optionLabel="name"
                    optionValue="personnelNumber"
                    [filter]="true"
                    [showClear]="true"
                    [group]="true">
                  </p-select>
                </div>
                <div class="mb-1" style="text-align: right">
                  <a
                    *ngIf="!isDisableLink"
                    class="small-link no-decoration"
                    (click)="removeCoOwner(i)"
                    >Remove</a
                  >
                </div>
              </div>
              <div class="mb-3" style="text-align: right">
                <a
                  *ngIf="preSelectedCoOwners < bacList.length && !isDisableLink"
                  class="small-link no-decoration"
                  (click)="addCoOwner()"
                  >Add co-owner</a
                >
              </div>
            </div>

            <!-- Job Name editable for presales projects (no order linked) -->
            <div
              *ngIf="!salesOrderIdD365 && isAllowedToShowJobName"
              class="form-group mb-3">
              <label class="form-label">Job Name<span></span></label>
              <input
                pInputText
                jniAutoCompleteBlocker
                type="text"
                class="form-control"
                formControlName="jobName"
                placeholder="Enter Job Name"
                [readonly]="isDisableLink" />
            </div>
          </div>
        </div>

        <div class="col-3 fixingflexcol">
          <div class="gray-bg-rounded min-hgt-rounded">
            <div class="mb-2">
              <h3>Proposal:</h3>
              <div
                class="mb-1"
                *ngIf="linkedProposals && linkedProposals.length > 0">
                <span
                  *ngFor="let proposalId of linkedProposals; let last = last">
                  <a
                    class="small-link mb-1"
                    (click)="redirectToProposal(proposalId)"
                    >{{ proposalId }}</a
                  >
                  <span *ngIf="!last">, </span>
                </span>
              </div>
              <!-- <button
                [class.disabled]="isDisableLink"
                style="width: 100%"
                type="button"
                class="btn btn-primary mb-2"
                (click)="openProposalModal()">
                Link Proposal
              </button> -->

              <p-button
                icon="pi pi-link"
                label="Link Proposal"
                [class.disabled]="isDisableLink"
                (click)="openProposalModal()" />

              <!-- <button *ngIf="!quoteId || quoteId == ''" style="width: 100%;" type="button" class="btn btn-secondary mb-2"
            (click)="createNewProposal()">New Proposal</button> -->
            </div>

            <div class="mb-2">
              <h3 class="mt-3">Order:</h3>
              <a class="small-link mb-1" (click)="redirectToSaleorder()">{{
                salesOrderIdD365
              }}</a>
              <!-- <button *ngIf="!salesOrderIdD365 || salesOrderIdD365 == ''" style="width: 100%;" type="button"
            class="btn btn-secondary mb-2" (click)="createNewOrder()">New Order</button> -->
            </div>
            <div class="mb-2">
              <!-- <button
                style="width: 100%"
                type="button"
                class="btn btn-primary mb-2"
                (click)="displayWorkflowEmailModal()">
                Generate Project PDF
              </button> -->

              <div class="d-flex mb-2">
                <p-button
                  icon="pi pi-file-pdf"
                  *ngIf="!salesOrderIdD365"
                  class="pb-2"
                  label="Link Order"
                  (click)="displayLinkOrderModal()">
                </p-button>

                <p-button
                  icon="pi pi-file-pdf"
                  label="Generate PDF"
                  class="mx-2 pb-2"
                  [class.disabled]="isDisableLink"
                  (click)="displayWorkflowEmailModal()"
                  *ngIf="!salesOrderIdD365" />
              </div>

              <div class="d-flex">
                <p-button
                  icon="pi pi-file-pdf"
                  label="Generate PDF"
                  [class.disabled]="isDisableLink"
                  (click)="displayWorkflowEmailModal()" />

                <p-button
                  icon="pi pi-clipboard"
                  class="mx-2"
                  label="Generate XLSX"
                  [disabled]="disableTrackingExcelDownload"
                  (click)="getTrackingSheetExcelTemplate()" />
              </div>

              <!-- <button
                style="width: 100%"
                type="button"
                class="btn btn-primary mb-2"
                [disabled]="disableTrackingExcelDownload"
                (click)="getTrackingSheetExcelTemplate()">
                Generate Tracking XLSX
              </button> -->
            </div>
          </div>
        </div>

        <div class="col-3 fixingflexcol">
          <div
            class="gray-bg-rounded min-hgt-rounded d-flex flex-column project-files-container"
            jniGlobalFileDrop
            [acceptedTypes]="[
              'pdf',
              'doc',
              'docx',
              'jpg',
              'jpeg',
              'png',
              'txt',
              'xlsx',
              'xls',
            ]"
            [maxFileSize]="30"
            [maxFiles]="10"
            [disabled]="
              isDisableLink || (projectFiles && projectFiles.length >= 10)
            "
            (filesDropped)="onProjectFilesDropped($event)"
            (filesRejected)="onFilesRejected($event)"
            title="Drag and drop files anywhere in this area to upload">
            <div class="d-flex align-items-end justify-content-between">
              <h3 class="mb-2 mt-2">Project Files</h3>
            </div>
            <div
              *ngIf="projectFiles && projectFiles.length > 0"
              class="mb-2 file-sec">
              <div
                *ngFor="let item of projectFiles"
                class="vendorDetails-download d-flex align-items-center justify-content-between mb-3">
                <div class="ms-2 d-flex align-items-center gap-2">
                  <div>
                    <img
                      *ngIf="!item.isLink"
                      class="icon"
                      [src]="getFileIconClass(item.fileName)"
                      alt="icon" />
                    <i *ngIf="item.isLink" class="icon pi pi-link"></i>
                  </div>
                  <div class="d-block">
                    <a
                      (click)="downloadProjectFile(item.fileUrl, item.fileName)"
                      *ngIf="!item.isLink"
                      class="d-block link"
                      style="font-size: small"
                      ><strong>{{ item.fileName }}</strong></a
                    >
                    <a
                      href="{{ item.fileUrl }}"
                      *ngIf="item.isLink"
                      class="d-block link"
                      rel="noopener noreferrer"
                      target="_blank"
                      style="font-size: small"
                      ><strong>{{ item.fileName }}</strong></a
                    >
                  </div>
                </div>
                <div class="gap-1 d-flex">
                  <i
                    class="pi pi-pencil"
                    *ngIf="!isDisableLink && item.isLink"
                    (click)="openProjectFileLinkDailog('Edit', item)"></i>
                  <i
                    class="pi pi-pencil"
                    *ngIf="!isDisableLink && !item.isLink"
                    (click)="
                      renameProjectFileDailog(item.fileId, item.fileName)
                    "></i>
                  <i
                    class="pi pi-times"
                    *ngIf="!isDisableLink && !item.isLink"
                    (click)="
                      deleteFileFromBlobStorage(item.fileId, item.fileUrl)
                    "></i>
                  <i
                    class="pi pi-times"
                    *ngIf="!isDisableLink && item.isLink"
                    (click)="deleteProjectFile(item.fileId)"></i>
                </div>
              </div>
            </div>
            <div
              *ngIf="projectFiles && projectFiles.length < 10"
              class="d-flex justify-content-end mt-auto gap-2">
              <!-- <p-button label="{{ "Upload File" }}" [disabled]="isDisableLink"
                (change)="uploadTrackingFile($event)" /> -->

              <!-- <label
                style="cursor: pointer"
                [ngClass]="
                  isDisableLink ? 'btn btn-primary disabled' : 'btn btn-primary'
                ">
                <input
                  pInputText
                  [disabled]="isDisableLink"
                  type="file"
                  style="display: none"
                  (change)="uploadTrackingFile($event)" />
                {{ "Upload File" }}
              </label> -->

              <!-- Hidden file input for drag and drop -->
              <input
                #fileInput
                type="file"
                style="display: none"
                (change)="uploadTrackingFile($event)"
                [disabled]="isDisableLink" />

              <p-button
                label="Upload File"
                icon="pi pi-cloud-upload"
                [disabled]="isDisableLink"
                (click)="fileInput.click()" />

              <!-- <button
                class="btn btn-primary ps-2"
                [disabled]="isDisableLink"
                (click)="openProjectFileLinkDailog('Add')">
                Add Link
              </button> -->

              <p-button
                icon="pi pi-link"
                label="Add Link"
                [disabled]="isDisableLink"
                (click)="openProjectFileLinkDailog('Add')" />
            </div>
          </div>
        </div>

        <div #updatesContainer class="col-3 fixingflexcol">
          <div class="gray-bg-rounded min-hgt-rounded">
            <jni-workflow-updates
              *ngIf="workflowId"
              [projectWorkflowId]="workflowId"
              [isWorkflowOwners]="isWorkflowOwners"
              [isDisableLink]="isDisableLink"
              (hasUnsavedChangesEvent)="onInputChange($event)">
            </jni-workflow-updates>
          </div>
        </div>
      </div>
    </form>

    <div class="gray-bg-rounded mt-3">
      <jni-project-task-list
        #salesTask
        *ngIf="showTaskGrids"
        [workflowId]="workflowId"
        [taskList]="salesTaskList"
        [userList]="assignedToUserList"
        [taskType]="taskType.Sales"
        [jobName]="jobName"
        [clientAccountNumber]="customerIdD365"
        [salesTaskSmallLoader]="salesTaskSmallLoader"
        [orderInHandDate]="orderInHandDate"
        (refreshGridEvent)="getSaleTaskList()"
        (hasUnsavedChangesEvent)="onInputChange($event)"
        (triggerContact)="triggerContactDialog($event)"
        [buyerName]="buyerName">
      </jni-project-task-list>
    </div>
    <div class="gray-bg-rounded mt-3">
      <jni-workflow-line-items
        #linesComponent
        [orderLines]="orderLines"
        [previousData]="previousData"
        [workflowId]="workflowId"
        [salesOrderIdD365]="salesOrderIdD365"
        [statusList]="workflowStatusList"
        [smallLoader]="showLineSmallLoader"
        [workflowStatus]="workflowStatus"
        [isDisableLink]="isDisableLink"
        (refreshWorflowLineItemsEvent)="refreshWorflowLineItems()"
        (dropEvent)="onDelete($event)"
        (showAllLinesEvent)="showAllLines($event)"
        (createProductionTaskEvent)="createProductionTaskEvent($event)"
        (refreshGridEvent)="getProductionTaskList()"
        (hasUnsavedChangesEvent)="
          onInputChange($event)
        "></jni-workflow-line-items>
    </div>
    <div class="gray-bg-rounded mt-3">
      <jni-project-task-list
        #productionTask
        *ngIf="showTaskGrids && workflowStatusList.length !== 0"
        [workflowId]="workflowId"
        [taskList]="productionTaskList"
        [userList]="assignedToUserList"
        [taskType]="taskType.Production"
        [clientAccountNumber]="customerIdD365"
        [salesTaskSmallLoader]="productionTaskSmallLoader"
        [productionStatusList]="workflowStatusList"
        (refreshGridEvent)="getProductionTaskList()"
        (refreshLineItemGridEvent)="refreshWorflowLineItems()"
        (hasUnsavedChangesEvent)="onInputChange($event)"
        (triggerContact)="triggerContactDialog($event)"
        [buyerName]="buyerName">
      </jni-project-task-list>
    </div>
  </div>
</div>

<p-dialog
  header="Add Order Number"
  [position]="'top'"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="orderNumberModal"
  [style]="{
    width: '300px',
    height: '250px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <label class="mt-2" style="font-size: small"
      >If you have order number</label
    >
    <div class="form-group has-float-label mb-3 mt-4">
      <label class="form-label">Sale Order Number</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control has-link disable-color" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
      <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeModalOrderNumber()">
        Cancel
      </button>
      <button class="btn btn-primary" type="submit">Apply</button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Reassign Workflow"
  [position]="'center'"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="reassingWorkflowModal"
  [style]="{
    width: '400px',
    height: '370px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col">
    <div class="form-group has-float-label mt-3">
      <label class="form-label">Workflow Owner<span></span></label>
      <p-select
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="newWorkflowOwner"
        (onChange)="checkSelectionReassign()"
        [filter]="true"
        [showClear]="true"
        pInputText
        [options]="availableOwners"
        optionLabel="projectName"
        optionValue="personnelNumber">
      </p-select>
    </div>
    <div class="form-group has-float-label mt-2">
      <label class="form-label">Reason<span></span></label>
      <textarea
        rows="3"
        [(ngModel)]="reason"
        cols="30"
        pInputText
        class="w-full w-100"
        (input)="checkSelectionReassign()"></textarea>
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeModalReassignWorkflow()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        [disabled]="enableReassignApply"
        type="button"
        (click)="reassignWorkflowEmail()">
        Apply
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeModalReassignWorkflow()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Apply"
        [disabled]="enableReassignApply"
        (click)="reassignWorkflowEmail()" />
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Add Proposal"
  [position]="'center'"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showProposalDialog"
  [style]="{
    width: '300px',
    height: '290px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mb-3">
      <label class="form-label">Proposal</label>
      <p-multiSelect
        pInputText
        appendTo="body"
        class="p-0"
        [(ngModel)]="selectedProposalIds"
        [showToggleAll]="false"
        [selectAll]="false"
        [options]="proposalIds"
        [filter]="true"
        [showClear]="true">
      </p-multiSelect>
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeProposalModal()">
        Cancel
      </button>
      <button
        [disabled]="!selectedProposalIds || selectedProposalIds.length === 0"
        class="btn btn-primary"
        type="click"
        (click)="addWorkflowProposals()">
        Apply
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeProposalModal()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Apply" (click)="addWorkflowProposals()" />
    </div>
  </div>
</p-dialog>

<jni-workflow-logs
  #reassignLogs
  *ngIf="workflowId"
  [workflowLogsModal]="workflowLogsModal"
  [workflowId]="workflowId"
  (openWorkflowLogsModalEvent)="openLogsScreen()"
  (closeWorkflowLogsModalEvent)="closeWorkflowLogsModal()">
</jni-workflow-logs>

<jni-chatbox
  #chatBox
  *ngIf="displayChat"
  [displayChat]="displayChat"
  (displayChange)="onHide()"
  [messageList]="messageList"
  (sendChatMessageEvent)="sendChatMessage($event)"
  [chatFirstCurrentDateIndex]="chatFirstCurrentDateIndex"
  [moduleName]="chatModuleName"
  [moduleId]="paddedWorkflowId"
  [users]="userTagList">
</jni-chatbox>

<jni-modal-stacker
  *ngIf="workflowEmailDisplayModal"
  [displayModal]="workflowEmailDisplayModal"
  (closeEvent)="closeModalForWorkflowEmail()">
  <h1 class="panelHeading mt-5">Proposed Project # {{ paddedWorkflowId }}</h1>
  <div class="panelBody">
    <jni-workflow-email
      [workflowEmailData]="workflowEmailData"
      [maskedWorflowId]="paddedWorkflowId"
      (closeModalEvent)="closeModalForWorkflowEmail()"></jni-workflow-email>
  </div>
</jni-modal-stacker>

<jni-notification-settings
  *ngIf="notificationSettings.length > 0"
  [viewSettingsModal]="viewSettingsModal"
  [notificationSettings]="notificationSettings"
  (closeUpdateSettingModalEvent)="showOrHideNotificationSettings()"
  [workflowId]="workflowId"
  [isGlobal]="false"
  (refreshDataEvent)="getNotificationSettings()"
  (dailogHideEventSettings)="hideNotificationSettingDailog($event)"
  (hasUnsavedChangesEvent)="onInputChange($event)">
</jni-notification-settings>

<jni-workflow-error-logs
  #errorLogs
  *ngIf="workflowId"
  [errorLogsModal]="errorLogsModal"
  [workflowId]="workflowId"
  (closeErrorLogsModalEvent)="closeErrorLogsModal()">
</jni-workflow-error-logs>

<!-- <jni-modal-stacker *ngIf="displayProposalSummaryModal && proposalSummaryId !== ''" [displayModal]="displayProposalSummaryModal"
  (closeEvent)="closeProposalSummaryModal()">
  <div class="panelBody">
    <jni-quote-summary [saleOrderIdFromModal]="proposalSummaryId"></jni-quote-summary>
  </div>
</jni-modal-stacker> -->

<p-dialog
  header="Rename File"
  [position]="'center'"
  [modal]="true"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showRenameProjectFileDailog"
  [style]="{
    width: '300px',
    height: '250px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="HundredWeightTrackingNumber"
        >File Name</label
      >
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="renameProjectFileName"
        name="renameProjectFileName"
        [(ngModel)]="renameProjectFileName"
        (change)="onInputChange(true)" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeRenameProjectFileDailog()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="saveRenameProjectFile()">
        Save
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeRenameProjectFileDailog()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Save" (click)="saveRenameProjectFile()" />
    </div>
  </div>
</p-dialog>

<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-dialog
  header="{{ projectFileLinkModalHeader }}"
  [position]="'center'"
  [modal]="true"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showAddProjectFileLinkModal"
  [style]="{
    width: '300px',
    height: '320px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="projectFileLink">File Link</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="projectFileLink"
        name="projectFileLink"
        [(ngModel)]="projectFileLink"
        (change)="onInputChange(true)" />
    </div>
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="projectLinkName">Link Name</label>
      <input
        pInputText
        jniAutoCompleteBlocker
        type="text"
        class="form-control"
        id="projectLinkName"
        name="projectLinkName"
        [(ngModel)]="projectLinkName"
        (change)="onInputChange(true)" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <!-- <button
        class="btn btn-secondary me-3"
        type="button"
        (click)="closeProjectFileLinkDailog()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        type="submit"
        (click)="editProjectFileLink()"
        *ngIf="projectFileLinkMode === 'Edit'">
        Update
      </button> -->

      <p-button
        label="Cancel"
        (click)="closeProjectFileLinkDailog()"
        variant="outlined"
        severity="secondary" />

      <p-button
        label="Update"
        (click)="editProjectFileLink()"
        *ngIf="projectFileLinkMode === 'Edit'" />

      <!-- <button
        class="btn btn-primary"
        type="submit"
        (click)="addProjectFileLink()"
        *ngIf="projectFileLinkMode === 'Add'">
        Save
      </button> -->

      <p-button
        label="Save"
        (click)="addProjectFileLink()"
        *ngIf="projectFileLinkMode === 'Add'" />
    </div>
  </div>
</p-dialog>

<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [headingStatus]="true"
  [addClientContact]="addClientContact"
  [customerAccountNumber]="customerIdWorkFlowDetails"
  (isContactAdded)="isContactAdded($event)"
  (populateContactAddedInfo)="populateContactAddedInfo($event)">
</jni-add-contact-information>

<p-dialog
  header="Add Order"
  [position]="'center'"
  [modal]="true"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showLinkOrderModal"
  [style]="{
    width: '300px',
    height: '320px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="projectFileLink">Order</label>
      <p-select
        [(ngModel)]="linkSelectedOrder"
        [filter]="true"
        [showClear]="true"
        [options]="salesorderList">
      </p-select>
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <p-button
        label="Cancel"
        (click)="closeLinkOrderModal()"
        variant="outlined"
        severity="secondary" />

      <p-button label="Add" (click)="applyTheOrderOnProject()" />
      <p-button
        label="Save"
        (click)="addProjectFileLink()"
        *ngIf="projectFileLinkMode === 'Add'" />
    </div>
  </div>
</p-dialog>
